module.exports = __webpack_public_path__ + "img/suit-heart-fill.d6595b67.svg";